import { Button, Modal, Paper } from "@mui/material";
import { shade } from "polished";
import { FC } from "react";
import { FaRegTimesCircle, FaSave } from "react-icons/fa";
import styled from "styled-components";
import { IModalProps } from "../../common/interfaces/IModalProps";

const ModalWrapper = styled(Paper)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  width: 450px;
  display: flex;
  flex-flow: column;
  container-type: inline-size;
  & > * {
    padding: 16px;
  }
`;

const ModalTitle = styled("div")`
  display: flex;
  postition: relative;
  justify-content: center;
  font-size: 18px;
  padding: 8px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.primary};
  border-bottom: 1px solid #e9ecef;
`;

const ModalCloseButton = styled("span")`
  position: absolute;
  right: 16px;
  top: 8px;
  cursor: pointer;
  color: #A9B0B7;
`;

const ModalContent = styled("div")`
  display: flex;
  text-align: center;
  color: #4c5667;
  font-size: 0.95rem;
`;

const ModalButtons = styled("div")`
  display: flex;
  justify-content: end;
  gap: 16px;
  padding: 8px;
  border-top: 1px solid #e9ecef;
`;

const ActionButton = styled(Button)`
  && {
    text-transform: none;
    font-family: "Versos", sans-serif;
    font-size: 16px;
    display: flex;
    align-items: center;
    padding: 4px 16px;
    svg {
      transition: all 0.5s;
    }
    @container (max-width: 440px) {
      font-size: 14px;
      padding: 8px 16px;
    }
  }
`;

const ConfirmButton = styled(ActionButton)`
  && {
    background-color: ${(props) => props.theme.colors.primary};
    color: white;

    &:hover {
      background-color: ${(props) => shade(0.2, props.theme.colors.primary)};
    }
  }
`;

interface IRecordConfirmationProps extends IModalProps {
  confirmAction: () => void;
}

const RecordConfirmationModal: FC<IRecordConfirmationProps> = ({
  opened = false,
  handleClose,
  confirmAction,
}) => {
  return (
    <Modal open={opened} container={document.getElementById("telemedicina-container") || undefined} onClose={handleClose} disableEscapeKeyDown>
      <ModalWrapper>
        <ModalTitle>Gravação do Teleatendimento
          <ModalCloseButton>
            <FaRegTimesCircle onClick={handleClose} size={18} fill="gray"/>
          </ModalCloseButton>
        </ModalTitle>
        <ModalContent>
          A gravação da chamada começa automaticamente quando o microfone ou câmera de um participante é ativado, 
          e será encerrada automaticamente assim que a conexão for finalizada.
        </ModalContent>
        <ModalButtons>
          <ConfirmButton
            startIcon={<FaSave size={18} />}
            onClick={confirmAction}
          >
            OK
          </ConfirmButton>
        </ModalButtons>
      </ModalWrapper>
    </Modal>
  );
};

export default RecordConfirmationModal;
